import { AstrocoinsReward, Purchase } from './deposit-service';

export interface Merchant {
  id: number;
  url: string;
  name: string;
  img: string;
  logo: string;
  merchantOperation: string;
  urlLogo?: string;
  user?: MerchantGatewayUserResponse;
  merchantType?: merchantTypes;
}

export enum DepositStatus {
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
  PENDING = 'PENDING',
  PURCHASE_PENDING = 'PURCHASE_PENDING',
}

export interface Deposit {
  amount: number;
  currency: string;
  status: DepositStatus;
  expiration: string;
  paymentMethodCode?: string;
  paymentMethodName?: string;
  paymentMethodEnforced?: boolean;
  paymentElementExternalId?: string;
  country: string;
  depositType?: DepositType;
}
export enum RestrictedCountries {
  NORWAY = 'NO',
  INDIA = 'IN',
}

export interface Discount {
  amount: number;
  currency: string;
  title: string;
  description: string;
}
export interface Bonus {
  amount: number;
  currency: string;
  finalAmount: number;
}

export interface CashBack {
  type: string;
  currency: string;
  amount: number;
  percentage: number;
  usdLimitAmount: number;
}

export interface Subscription {
  description: string;
  frequency: SubscriptionFrequency;
  status: SubscriptionStatus;
  amount: number;
  country: string;
  currency: string;
}

export interface Wallet {
  balance: number;
  currency: string;
}

export interface DepositMethods {
  wallet: boolean;
  card: boolean;
  paymentMethod: boolean;
  teller: boolean;
  anonymousCard: boolean;
}
export interface MerchantNotification {
  title?: string;
  body: string;
}

export interface DefaultPaymentMethod {
  code: string;
  name: string;
}

export interface VisualInfo {
  merchantName?: string;
  merchantLogo?: string;
  paymentMethodName?: string;
  paymentMethodLogo?: string;
}

export interface MerchantGatewayUserResponse {
  id: number;
  fullName: string;
  phone: string;
  notify: boolean;
  validateSameUser: boolean;
  address?: {
    zip: string;
    line1: string;
    line2: string;
    city: string;
    province: string;
    country: string;
  };
  email?: string;
  firstName?: string;
  lastName?: string;
  birthDate?: string;
  document?: string;
  documentType?: string;
}

export enum DepositType {
  FULL_GATEWAY = 'FULL_GATEWAY',
  DEFAULT = 'DEFAULT',
}

export enum Flavours {
  BASIC = 'BASIC',
  REQUIRES_CONFIRM = 'REQUIRES_USER_CONFIRMATION',
  RESELLER_ONLY = 'RESELLER_ONLY',
  REVERSE = 'Reverse',
  REVERSE_V2 = 'Reverse V2',
}

export enum CustomLanding {
  APC = 'APC',
  PM = 'payment_methods',
  PM_V2 = 'payment_methods_v2',
  AUTH_V2 = 'AUTH_V2',
  AUTH = 'AUTH',
}

export enum CustomTopUp {
  APP = 'app',
}

export enum SubscriptionStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum SubscriptionFrequency {
  MONTHLY = 'montly',
  WEEKLY = 'weekly',
  DAILY = 'daily',
}

export enum postAction {
  REDIRECT = 'REDIRECT',
  DEFAULT = 'DEFAULT',
}

export enum merchantTypes {
  MICROMERCHANT = 'MICRO',
  MERCHANT = 'MERCHANT',
}

export interface MerchantDepositDetail {
  deposit: Deposit;
  user?: MerchantGatewayUserResponse;
  merchant: Merchant;
  depositFinalAmount: number;
  visualInfo?: VisualInfo;
  bonus?: Bonus;
  discounts?: Discount[];
  cashbackBonus?: CashBack;
  astrocoins?: AstrocoinsReward;
  depositMethods?: DepositMethods;
  notifications?: MerchantNotification[];
  flavour: Flavours;
  customFlow?: { landing?: CustomLanding; walletTopUp?: CustomTopUp };
  countryByIp?: string;
  subscription?: Subscription;
  shouldShowPromoCode?: boolean;
  postAction: postAction;
  restrictedByCountry?: boolean;
}

export const defaultDepositMethods: DepositMethods = {
  wallet: true,
  card: true,
  paymentMethod: true,
  teller: false,
  anonymousCard: true,
};

export interface GatewayDepositDetail extends MerchantDepositDetail {
  purchase: Purchase;
}

export interface GatewayDirectDeposit {
  merchandDepositId: string;
  depositExternalId: string;
  status: DepositStatus;
  paymentDetail: {
    qr: string;
    qrImage: string;
  };
}

export enum EStatusCardInfo {
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
  NEW = 'NEW',
  PENDING = 'PENDING',
  USED = 'USED',
}
